import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';

import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import request from 'utils/request';
import urls from 'utils/config';

import { deleteFormsSuccess, deleteFormsFailure } from '../actions';
import FormsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { FORM_API_BASE_URL } = urls || {};

function* deleteForm({ id }) {
  const url = `${FORM_API_BASE_URL}/designs/${id}`;

  const response = yield request({
    method: 'delete',
    url,
  });
  if (response.success) {
    Notify('Form Deleted Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    yield put(deleteFormsSuccess(id));
  } else {
    yield put(deleteFormsFailure(response.message));
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* onFormDelete() {
  yield takeLatest(FormsActionTypes.START_DELETE_FORMS, deleteForm);
}
